import { render, staticRenderFns } from "./CustomRoleForm.vue?vue&type=template&id=6e79b13a&scoped=true&"
import script from "./CustomRoleForm.vue?vue&type=script&lang=js&"
export * from "./CustomRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomRoleForm.vue?vue&type=style&index=0&id=6e79b13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79b13a",
  null
  
)

export default component.exports